import { ReactNode, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { changeSetting } from '../../store/ui.settings/actions';

import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css"

import Header from './Header'
//import Offsidebar from './Offsidebar'
import Footer from './Footer'
import { PageLoader } from '../../common/PageLoader/PageLoader';
import { PromptContainer } from '../../common/Modals/PromptContainer';

export interface BaseProps {
    children: ReactNode;
    changeSetting: typeof changeSetting;
}

const Base = (props: BaseProps) => {

    useEffect(() => {
        props.changeSetting({ name: 'horizontal', value: true });

        return () => {
            props.changeSetting({ name: 'horizontal', value: false });
        }
    }, [props]);

    //return <div className="wrapper"></div>;
    return (
        <div className="wrapper">
            <PageLoader />
            <Header />
            <ToastContainer position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover />
            <section className="section-container" id="page-section-container">
                {props.children}
            </section>
            <PromptContainer />
            <Footer />
        </div>
    );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({ changeSetting: bindActionCreators(changeSetting, dispatch) });

export default connect(
    null,
    mapDispatchToProps
)(Base);
